import { useEffect, useRef, useCallback } from "react";
import { debounce, isServer } from "../utils/other";

const EVENTS = ["mousedown", "mousemove", "keypress", "scroll", "touchmove"];

const useUserActivity = (handler, ms) => {
  const handlerRef = useRef();

  const callback = useCallback(() => handlerRef.current(), []);

  useEffect(() => {
    if (handlerRef.current && handlerRef.current.cancel) {
      handlerRef.current.cancel();
    }
    handlerRef.current = debounce(handler, ms);
  }, [handler, ms]);

  useEffect(() => {
    EVENTS.forEach(event => {
      if (!isServer()) {
        // eslint-disable-next-line no-undef
        document.addEventListener(event, callback, true);
      }
    });

    return () => {
      EVENTS.forEach(event => {
        if (!isServer()) {
          // eslint-disable-next-line no-undef
          document.removeEventListener(event, callback);
        }
      });
    };
  }, [callback]);
};

export default useUserActivity;
